module.exports = __webpack_public_path__ + "static/shapes-1_PLACEHOLDER-4bc8e45b6c3dee98f33b893c50981e3a.jpg";